/**
 * Main page implementation.
 *
 * @author Dmytro Fedotov <d.fedotov@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var id            = 'pageUrl',
    Page          = require('stb-component-page'),
    app           = require('mag-app'),
    page          = new Page({$node: document.getElementById(id)}),
    PanelSet      = require('mag-component-panel-set'),
    PanelExtended = require('mag-component-panel'),
    LayoutList    = require('mag-component-layout-list'),
    dom           = require('spa-dom'),
    keys          = require('stb-keys'),
    Flicker       = require('spa-component-flicker'),
    Button        = require('stb-component-button'),
    $channelsCountWrapper;


$channelsCountWrapper = dom.tag(
    'div',
    {className: 'amountContainer'},
    dom.tag('div', {className: 'amount'}, '1')
);


page.clock = new Flicker({
    className: 'clock',
    interval: 1000,
    render: function ( $item ) {
        var time  = new Date(),
            hours = time.getHours(),
            mins  = time.getMinutes();

        $item.innerText = (hours > 9 ? hours : '0' + hours) + ':' + (mins > 9 ? mins : '0' + mins);
    }
});
page.add(page.clock);
page.clock.start();


// middle panel (list)
page.middlePanel = new PanelExtended({
    title: [{value: gettext('Update URL'), className: 'name'}, $channelsCountWrapper],
    main: true,
    children: [],
    className: 'middlePanel'
});


page.middlePanel.add(page.middlePanel.list = new LayoutList({
    cycle: true,
    focusIndex: 0,
    size: 6,
    className: 'padded',
    events: {
        overflow: function () {
            page.middlePanel.list.$focusItem.classList.remove('focus');
            page.middlePanel.button.focus();
        },
        keydown: function ( event ) {
            LayoutList.prototype.defaultEvents.keydown.call(this, event);
        }
    },
    data: [
        {
            items: [
                {className: 'item name theme-subhead-color', value: gettext('URL:')},
                page.input = dom.tag(
                    'div',
                    {className: 'item text'},
                    page.input ? page.input.innerText : app.updater.updateImageUrl
                )
            ],
            className: 'theme-item-editable',
            click: function () {
                window.core.intent({
                    action: 'keyboard',
                    data: {
                        type: 'text',
                        mode: 'qwerty',
                        title: gettext('ENTER URL'),
                        description: gettext('UPDATE MANAGER'),
                        value: page.input.innerText
                    },
                    events: {
                        done: function ( event ) {
                            page.input.innerText = event.value;
                            page.confirmedImage = null;
                            page.middlePanel.button.$text.innerText = gettext('CHECK');
                        }
                    }
                }, function ( error ) {
                    if ( error ) { console.log(error); }
                });
            }
        }
    ]
}));


page.middlePanel.add(page.middlePanel.button = new Button({
    value: gettext('CHECK'),
    className: 'bottom theme-footer',
    $node: page.middlePanel.$node.appendChild(document.createElement('div')),
    events: {
        click: function () {
            if ( page.confirmedImage ) {
                app.route(app.pages.info, [page.confirmedImage]);
            } else {
                console.log('check image by url: ' + page.input.innerText);
                app.updater.check({uri: page.input.innerText}, function ( error, data ) {
                    console.log('check error? ' + error);
                    console.log('data? ' + /*JSON.stringify*/(data));
                    if ( error ) {
                        window.core.notify({
                            title: gettext('Can\'t check this image') + ': ' + error.message,
                            icon: 'alert',
                            type: 'warning'
                        });
                    } else if ( !data || (data.date || '').toString() === 'Invalid Date' ) {
                        window.core.notify({
                            title: gettext('Can\'t check this image'),
                            icon: 'alert',
                            type: 'warning'
                        });
                    } else {
                        page.middlePanel.button.$text.innerText = gettext('CONTINUE');
                        page.confirmedImage = data;
                    }
                });
            }
        },
        keydown: function ( event ) {
            if ( event.code === keys.up ) {
                page.middlePanel.list.focus();
                // restore taken focus class
                page.middlePanel.list.$focusItem.classList.add('focus');
                page.middlePanel.list.focusIndex(page.middlePanel.list.data.length - 1);
            } else if ( event.code === keys.down ) {
                page.middlePanel.list.focus();
                // restore taken focus class
                page.middlePanel.list.$focusItem.classList.add('focus');
                page.middlePanel.list.focusIndex(0);
            } else if ( event.code === keys.ok ) {
                if ( page.middlePanel.button.events['click'] ) {
                    page.middlePanel.button.emit('click', {event: event});
                }
            }
        }
    }
}));


// panel set: main
page.panelSet = new PanelSet({
    visible: true,
    $node: document.getElementById('panelSetUrl'),
    focusIndex: 0,
    panels: [page.middlePanel]
});
page.add(page.panelSet);


page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            app.route(app.pages.main);
            break;
    }
});


page.addListener('show', function () {
    page.confirmedImage = null;
    page.middlePanel.button.$text.innerText = gettext('CHECK');
    page.panelSet.show();
    page.panelSet.focus();
    // give focus to button
    page.middlePanel.list.$focusItem.classList.remove('focus');
    page.middlePanel.button.focus();
});


// public
module.exports = page;
